export default __webpack_public_path__ + "static/media/include_14_female@3x.2b5b0fa1.jpg";